export default "__VITE_ASSET__39d98151__"